// @flow
import $ from 'jquery';
import JQueryView, { on, removeInvalidFeedback } from '../common/JQueryView';
import SearchAddressForm from '../common/SearchAddressForm';

export default class FormView extends JQueryView {
  searchAddress: Object;

  constructor() {
    super('.simple_form');
    this.searchAddress = new SearchAddressForm('.simple_form');
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);

      // 郵便番号フォームの場合は「住所を検索する」ボタンの位置を調整する
      if (target.hasClass('zip_code_form')) {
        $('#address_button').css('top', '51%');
      }
      target.removeClass('focus');
    }
  }
}
